import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withTheme } from '@material-ui/core';

class ShutterStoreIcon extends PureComponent {
    static propTypes = {
        size: PropTypes.number,
        color: PropTypes.string
    };

    static defaultProps = {
        size: 50,
        color: '#8e8e8e'
    };

    render() {
        const { color, size } = this.props;
        return (
            <svg height={(size / 1.5).toString()} width={(size / 1.5).toString()} viewBox="0 0 300 234.73">
                <g fill={color}>
                    <path d="M25.94 167.87h244.79v27.55H25.94zM25.94 128.57h244.79v27.55H25.94zM25.94 207.18h244.79v27.55H25.94zM25.94 89.26h244.79v27.55H25.94z" />
                    <path d="M272 0H28A28 28 0 0 0 0 28v22h25.94v27.49h244.78V50.02h8.39v79.45H289V50.02h11v-22A28 28 0 0 0 272 0zM279.11 139.37v33.55a4.94 4.94 0 1 0 9.88 0v-33.55h-9.88z" />
                </g>
            </svg>
        );
    }
}

export default withTheme(ShutterStoreIcon);



// WEBPACK FOOTER //
// ./data/common/iconsvg/ShutterStoreIcon.js